import { render } from "./resource-notice.vue?vue&type=template&id=539cb2f1&scoped=true"
import script from "./resource-notice.vue?vue&type=script&lang=js"
export * from "./resource-notice.vue?vue&type=script&lang=js"

import "./resource-notice.vue?vue&type=style&index=0&id=539cb2f1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-539cb2f1"]])

export default __exports__